<template>
    <div v-if="allLocations.length > 0" class="locationsArea">

        <div 
            v-for="(location, index) in allLocations" 
            :key="index" class="location image" 
            :style="'background-image:url('+ location.imageUrl +');'" 
            :class="{active: currentCity === location.city}"
            @click.prevent="updateLocation(location.city)"
        >
            <div class="locationDimmer">
                <div class="locationContent">
                    <h4>{{ location.city }}</h4>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data(){
            return{
                currentCity: '',
                allLocationsObj: {},
                allLocations: []
            }
        },
        beforeMount(){

            this.currentCity = this.$store.state.location.city

            let defaultLocation = window.localStorage.getItem('defaultLocation')

            if(defaultLocation !== null || typeof(defaultLocation) !== 'undefined'){
                this.currentCity = defaultLocation
            }

            // console.log('Before mount city: ', this.currentCity)

            let tempLocationsObj = this.$store.state.locations
            this.allLocationsObj = tempLocationsObj
            
            let tempAllLocations = []

            Object.keys(tempLocationsObj).forEach(function(key){
                tempAllLocations.push(tempLocationsObj[key])
            })

            this.allLocations = tempAllLocations
        },
        methods: {
            updateLocation(city){

                if(this.currentCity === city) return

                let currentCity = city
                let newLocation = this.allLocationsObj[city]

                window.localStorage.setItem('defaultLocation', newLocation.city)

                this.$store.dispatch('updateLocation', newLocation)
                this.$emit('updateComponents')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Locations.vue